import { FieldsProps } from "../fields";
import {
  TextBlockItem,
  TextBlockProps,
} from "../questionnaire-designer/components/text-blocks/component/item";

import { QuestionnaireFieldAddDto } from "@common/dto/questionnaire/field/add-dto";
import { QuestionnaireFieldUpdateDto } from "@common/dto/questionnaire/field/update-dto";

export type UpdatedLocalTexts<T> = Array<Omit<FieldsWithTextBlocksItem<T>, 'itemType'>>;
export type UpdatedLocalFields<F> = Array<Omit<FieldsWithTextBlocksItem<F>, 'itemType'>>;

export type FieldsWithTextBlocksProps<F extends FieldInList, T extends TextBlockItem> = {
  fieldProps: Omit<
    FieldsProps<F>,
     "disabled" | "onOrderChange" | "data" | "onDelete"
  >;
  combinedItems: Array<FieldsWithTextBlocksItem<F> | FieldsWithTextBlocksItem<T>>;
  textBlocksProps: Omit<TextBlockProps<T>, "data" | "onDelete"> & {
    hasError?: (item: T) => boolean;
    getClassName?: (item: T) => string;
  };
  disabled?: boolean;
  onChange: (changedFields: {
    texts: UpdatedLocalTexts<T>;
    fields: UpdatedLocalFields<F>;
  }) => void;
};

export enum FieldsWithTextBlocksItemType {
  field = "field",
  textBlock = "textBlock",
}

export type FieldsWithTextBlocksItem<T> = T & {
  itemType: FieldsWithTextBlocksItemType;
  order: number;
};

export type FieldInList = {
  id: string;
  name: string;
  original: QuestionnaireFieldUpdateDto | QuestionnaireFieldAddDto;
};